import { Controller, Payload } from "../../config/controller";
import store, { ApplicationState } from "../../../core/store";
import { bindActionCreators, Dispatch } from "redux";

import { Procedimento, initialValueProcedimentoState, ProcedimentoState, ProcedimentoActions } from "./procedimento.model"
import { action } from "typesafe-actions";
import { call, put, takeLatest } from "redux-saga/effects";
import { ResultDb } from "../../services/db";
import { StatusAppState } from "../root/root.model";

export interface ProcedimentoViewProps {
    procedimentoState: ProcedimentoState
    procedimentoActions: ProcedimentoActions
}


class ProcedimentoController extends Controller<Procedimento, ProcedimentoState, ProcedimentoActions> {
    constructor() {
        super(initialValueProcedimentoState.row.type, initialValueProcedimentoState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
            selecionarProcedimento:`@${this.moduloName}/SELECIONAR_PROCEDIMENTO`

        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            selecionarProcedimento:(set)=>action(this.actionsType.selecionarProcedimento, {set}),
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.selecionarProcedimento,this.selecionarProcedimentoEffects.bind(this))

        ]
    }


    private * selecionarProcedimentoEffects(actions:Payload){
        try {
            yield put(this.reducer.resultAfterEffects({
                ...this.state, showSelectModal:actions.payload.set
            },this.actionsType.selecionarProcedimento))           
            if(this.state.rows.length === 0){
                yield put(this.reducer.actions.read())
            }
        } catch (error:any) {
            console.log("error selecionarProcedimentoEffects", error);
            let msg = "Ops, ocorreu uma falha em selecionarProcedimentoEffects, detalhes: ";
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg, status: "error", error: true, showAlert: true },
                this.actionsType.selecionarProcedimento
            ))            
        }
    }

    private * procedimentoReadAllEffects(actions: Payload) {

    }
}

export const procedimentoController = new ProcedimentoController()

export const mapStateToProcedimentoProps = (state: ApplicationState) => ({
    procedimentoState: state.procedimentoState,
})

export const mapDispatchToProcedimentoProps = (dispatch: Dispatch) => ({
    procedimentoActions: bindActionCreators({ ...procedimentoController.reducer.actions }, dispatch),
})

/*export const handleSelecionarProcedimento = (set:boolean) => {
    store.dispatch(procedimentoController.reducer.actions.setShowSelectModal(set));
    if(procedimentoController.state.rows.length === 0)
        store.dispatch(procedimentoController.reducer.actions.read())
}*/